import template from './sw-cms-el-preview-category-navigation.html.twig';
import './sw-cms-el-preview-category-navigation.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
